var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeadphoneMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 416,
    height: 412,
    viewBox: "0 0 416 412",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M230.539 144.933C220.636 154.554 220.408 170.382 230.029 180.285L335.55 288.893C345.171 298.796 360.998 299.024 370.901 289.403L401.461 259.712L261.098 115.242L230.539 144.933Z",
    fill: "#1C1C1C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M236.502 139.14L376.877 283.622L401.473 259.724L261.099 115.242L236.502 139.14Z",
    fill: "#F1C40F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M330.802 186.991L401.454 259.71L376.871 283.595L306.219 210.876L330.802 186.991Z",
    fill: "#F39C12"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M267.993 108.551C270.766 105.857 275.198 105.921 277.892 108.694L408.517 243.142C411.211 245.914 411.147 250.346 408.374 253.04L403.549 257.728L263.168 113.239L267.993 108.551Z",
    fill: "#E67E22"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M383.899 212.327L310.98 137.274C330.499 128.934 356.223 138.645 370.382 153.218C384.541 167.792 392.07 193.765 383.899 212.327Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.43677
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M387.561 201.575L323.034 133.637C339.561 131.875 359.947 141.472 370.276 151.82C380.605 162.169 389.878 179.606 387.561 201.575Z",
    fill: "#1C1C1C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M153.408 224.66C162.362 214.149 178.14 212.886 188.651 221.839L303.928 320.031C314.439 328.984 315.701 344.763 306.748 355.274L279.12 387.709L125.78 257.096L153.408 224.66Z",
    fill: "#1C1C1C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M148.018 230.989L301.371 361.614L279.133 387.721L125.78 257.096L148.018 230.989Z",
    fill: "#F1C40F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M201.934 321.958L279.118 387.703L301.344 361.61L224.16 295.865L201.934 321.958Z",
    fill: "#F39C12"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M119.554 264.414C117.047 267.357 117.401 271.775 120.344 274.282L263.047 395.835C265.99 398.341 270.408 397.988 272.914 395.045L277.277 389.923L123.917 259.292L119.554 264.414Z",
    fill: "#E67E22"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M230.688 373.284L151.027 305.43C143.981 325.452 155.354 350.486 170.822 363.662C186.29 376.838 212.7 382.652 230.688 373.284Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.43677
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M220.198 377.642L148.186 317.696C147.509 334.303 158.418 354.018 169.42 363.648C180.422 373.278 198.428 381.39 220.198 377.642Z",
    fill: "#1C1C1C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M279.31 38C304.054 62.849 331.992 82.9572 365.5 86L402 163.259L393.609 170.359L269 47.7756L279.31 38Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M274.832 42.1971L399.938 164.413L393.236 169.992L269 47.9345L274.832 42.1971Z",
    fill: "#1C1C1C"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3545 281.639C62.239 302.904 85.8434 327.958 93.2619 360.775L174.647 386.809L180.583 377.558L42.6909 270.134L34.3545 281.639Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M37.927 276.648L175.52 384.613L180.17 377.237L42.8484 270.113L37.927 276.648Z",
    fill: "#1C1C1C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M112 79C138 27 197.489 28.6534 269.552 53.0423C287.822 49.9936 290.36 30.6852 274.627 18.9986C206.113 -9.96325 132.017 -6.91465 78.728 35.7664L40.1572 73.875C-8.05815 131.801 -10.0829 204.969 19.3493 276.105C32.0406 291.349 53.8635 286.268 52.8485 266.451C28.999 201.921 26 149.5 71.6228 122L112 79Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M275.467 36.0335C194.826 8.73133 142.851 18.4185 96.0021 50.2538L53.9754 91.7771C11.9527 137.852 6.27732 202.697 32.966 274.935C33.1483 278.495 32.6724 281.631 31.686 284.315C27.3254 283.143 22.9665 280.45 19.3493 276.105C-10.0829 204.969 -8.05815 131.801 40.1572 73.875L78.728 35.7664C132.017 -6.91464 206.113 -9.96325 274.627 18.9986C280.031 23.0129 283.28 27.9264 284.475 32.7714C282.008 34.3104 279.001 35.4438 275.467 36.0335Z",
    fill: "#1C1C1C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphoneMobile);
export default __webpack_public_path__ + "static/media/headphone-mobile.5a9730938f89edcbdfbfd91933c7221a.svg";
export { ForwardRef as ReactComponent };